import { Box, Link, Typography } from '@mui/material';
import { MemberChangeLog } from 'src/modules/member/models/memberChangeLog';
import { DateHelper } from 'src/shared/helpers/dateHelper';
import { RoutesEnum } from 'src/shared/models/enums/routes.enum';
import { OverflowTooltip } from './overflowTooltip';

type DashboardLogItemProps = {
  item: MemberChangeLog;
};
export const DashboardLogItem = (props: DashboardLogItemProps) => {
  const { item } = props;

  const TextItem = ({ text, ml = 0 }) => (
    <Typography ml={ml} variant='body2' color={(thm) => thm.palette.text.primary}>
      {text}
    </Typography>
  );

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', pl: 2.5, py: 1, borderTop: (thm) => `1px solid ${thm.palette.divider}` }}>
      <Box display='flex' flexDirection='row' justifyContent='space-between'>
        <OverflowTooltip>{item.signature || ''}</OverflowTooltip>
        <TextItem ml={1} text={DateHelper.getTime(item.date)} />
      </Box>
      <Box display='flex'>
        <TextItem text={item.action} />
      </Box>
      <Box>
        <Link variant='body2' href={`${RoutesEnum.MemberDetails}/${item.member_id}`}>
          {`${item.memberFirstName} ${item.memberLastName}`}
        </Link>
      </Box>
    </Box>
  );
};
